export default __webpack_public_path__ + "static/logo-mobile-7dd8d31f4b5642417f30aa2177f06d8d.jpeg";